/**
 * Centralized date formatting helpers.
 * All dates across the app are displayed as dd-mm-yyyy.
 * Dates that include a time are displayed as dd-mm-yyyy HH:mm (24-hour).
 */

const pad = (n) => String(n).padStart(2, '0');

/**
 * Format a date value as dd-mm-yyyy.
 * Returns an empty string for missing/invalid values.
 */
export function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
}

/**
 * Format a date value as dd-mm-yyyy HH:mm (24-hour).
 * Returns an empty string for missing/invalid values.
 */
export function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
